import axiosInstance from "shared/services";
import { IBucketListResponse, ICompanies } from "modules/companies/types";

const uri = "companies";

export const all = async (
  filterCompanies: boolean = true,
  deleted: boolean = false
): Promise<ICompanies> =>
  axiosInstance
    .get(
      `${uri}/all?filterCompanies=${filterCompanies ? 1 : 0}&deleted=${
        deleted ? 1 : 0
      }`
    )
    .then();

export const getDashboard = async (filters: {
  companyId: number;
  month: string;
  download: boolean;
}) => {
  let headers = {};

  if (filters.download) {
    headers = {
      headers: {
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    };
  }

  return axiosInstance.get(
    `${uri}/dashboard/${filters.companyId}/${filters.month}/${filters.download}`,
    headers
  );
};

export const createFtp = async (companyId: number) =>
  axiosInstance.post(`${uri}/ftp/configure`, { companyId });

export const toogleFtp = async (companyId: number) =>
  axiosInstance.post(`${uri}/ftp/toggle`, { companyId });

export const downloadUnmaskedFiles = async (companyId: number) =>
  axiosInstance.get(`${uri}/unmasked-files-report/${companyId}`, {
    headers: {
      "Content-Type": "blob",
    },
    responseType: "arraybuffer",
  });

export const getById = async (companyId: number) =>
  axiosInstance.get(`${uri}/${companyId}`);

export const getBucketList = async (): Promise<IBucketListResponse> =>
  axiosInstance.get(`${uri}/bucket-list`);
